import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { CircularProgress, Box } from '@mui/material';

const PermissionGuard = ({ 
  resource, 
  action = 'read', 
  children, 
  fallback = null,
  requireAll = false,
  permissions = null,
  showLoading = false
}) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return showLoading ? (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    ) : fallback;
  }

  if (permissions && Array.isArray(permissions)) {
    const hasRequiredPermissions = requireAll
      ? permissions.every(({ resource: res, action: act }) => hasPermission(res, act))
      : permissions.some(({ resource: res, action: act }) => hasPermission(res, act));
    
    return hasRequiredPermissions ? children : fallback;
  }

  const hasRequiredPermission = hasPermission(resource, action);
  return hasRequiredPermission ? children : fallback;
};

export default PermissionGuard;